export const defaultRequiredText = "Please enter a value"
